import { formatLargeAmount, getAmountPrefixAndColor } from '@libs/helpers';
import { formatDate } from '@libs/hooks';
import { AppColors } from '@libs/theme';
import { CurrencySymbol } from '@libs/types';

export const formatChartDate = (val: string) => {
  const day = formatDate('D', val);

  const month = formatDate('MMM', val).slice(0, 3);

  return day + ' ' + month;
};

export const getYAxisPoints = (
  colors: AppColors,
  point: number,
  currencySymbol: CurrencySymbol
) => {
  const { absoluteAmount, prefix } = getAmountPrefixAndColor(colors, point);
  const prefixToApply = point > 0 ? '' : prefix;
  const shortenedAmount =
    absoluteAmount < 1000
      ? absoluteAmount.toFixed(2)
      : formatLargeAmount(absoluteAmount);

  return `${prefixToApply}${shortenedAmount}${currencySymbol}`;
};
